'use client';

import Link from 'next/link';
import Image from 'next/image';

export function Footer() {
  return (
    <footer className='px-4 py-12 text-white' style={{ backgroundColor: '#000054' }}>
      <div className='mx-auto max-w-7xl'>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-4'>
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <Image
                src="/logo/LOGO-ALT-HORIZONTAL-BASELINE-BLANC.svg"
                alt="All Manager Logo"
                width={180}
                height={50}
                className="h-12 w-auto"
              />
            </div>
            <p className='mb-4 text-blue-100 text-sm'>
              Digitalisez votre menuiserie
            </p>
            <p className="text-blue-100 text-sm">
              Rejoins l'ERP qui te permet d'administrer tous les aspects de ton entreprise de menuiserie, de booster ta productivité et gagner du temps.
            </p>
          </div>

          {/* Le logiciel */}
          <div>
            <h3 className='mb-4 font-semibold text-lg'>Le logiciel</h3>
            <ul className="space-y-2">
              <li>
                <Link href="https://allmanager.fr/erp/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  ERP
                </Link>
              </li>
              <li>
                <Link href="https://allmanager.fr/fonctionnalites/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Fonctionnalités
                </Link>
              </li>
              <li>
                <Link href="https://allmanager.fr/tarification/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Tarif
                </Link>
              </li>
            </ul>
          </div>

          {/* Formations */}
          <div>
            <h3 className='mb-4 font-semibold text-lg'>Formations</h3>
            <ul className="space-y-2">
              <li>
                <Link href="https://allmanager.fr/all-manager-votre-organisme-de-formation/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Académie
                </Link>
              </li>
              <li>
                <Link href="https://allmanager.fr/all-manager-votre-organisme-de-formation/tarification/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Formations
                </Link>
              </li>
              <li>
                <Link href="https://allmanager.fr/all-manager-votre-organisme-de-formation/certifications/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Certifications
                </Link>
              </li>
            </ul>
          </div>

          {/* Nous contacter */}
          <div>
            <h3 className='mb-4 font-semibold text-lg'>Nous contacter</h3>
            <ul className='mb-6 space-y-2'>
              <li>
                <a href="mailto:contact@allmanager.fr" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  contact@allmanager.fr
                </a>
              </li>
              <li>
                <Link href="https://allmanager.fr/contact/" className='text-blue-100 text-sm transition-colors hover:text-white'>
                  Contact
                </Link>
              </li>
            </ul>

            {/* LinkedIn Icon */}
            <div className="mb-6">
              <a href="https://linkedin.com" className='text-blue-100 transition-colors hover:text-white'>
                <svg className='h-6 w-6' fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>

            {/* Qualiopi Badge */}
            <div className='inline-block rounded-lg bg-white p-4'>
              <div className="text-center">
                <div className='mb-1 font-bold text-blue-900 text-lg'>Qualiopi</div>
                <div className='mb-2 text-blue-900 text-xs'>processus certifié</div>
                <div className='mb-2 flex items-center justify-center gap-1'>
                  <div className='h-2 w-3 bg-blue-900' />
                  <div className='h-2 w-3 bg-red-600' />
                  <div className='h-2 w-3 bg-blue-900' />
                </div>
                <div className='font-semibold text-blue-900 text-xs'>RÉPUBLIQUE FRANÇAISE</div>
              </div>
            </div>

            <div className="mt-4 text-blue-100 text-xs">
              <p>La certification qualité a été délivrée au titre de la catégorie d'action suivante :</p>
              <p className='mt-2 font-semibold'>ACTIONS DE FORMATIONS</p>
              <div className='mt-2 flex items-center gap-1'>
                <svg className='h-4 w-4' fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7v10c0 5.55 3.84 9.739 9 11 5.16-1.261 9-5.45 9-11V7l-10-5z"/>
                </svg>
                <span className="text-xs">Certificat Qualiopi</span>
              </div>
            </div>
          </div>
        </div>

        {/* Liens utiles */}
        <div className='mt-12 border-blue-800 border-t pt-8'>
          <div className='flex flex-col items-start justify-between md:flex-row md:items-center'>
            <div>
              <h4 className='mb-2 font-semibold'>Liens utiles</h4>
              <Link href="/a-propos" className='text-blue-100 text-sm transition-colors hover:text-white'>
                À propos
              </Link>
            </div>
            
            <div className='mt-4 text-blue-100 text-xs md:mt-0'>
              <div className='flex flex-col gap-4 md:flex-row'>
                <Link href="/politique-confidentialite" className='transition-colors hover:text-white'>
                  Politique de confidentialité
                </Link>
                <Link href="/mentions-legales" className='transition-colors hover:text-white'>
                  Mentions légales
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
